import { InjectionToken } from '@angular/core';
import { IAuthStrategy } from '../interfaces/auth-strategy.interface';

/** 具象認証戦略クラス（Internal/External）を注入するためのInjectionToken */
export const AUTH_STRATEGY = new InjectionToken<IAuthStrategy>('AUTH_STRATEGY');
